import get from 'lodash/get';

export const filters = state => get(state, 'form.reportsPricesFilter.values');